import React, { useState } from "react";
import { ClientContext } from "./context";
import { useWindowSize } from "../client/hooks/Hooks";

export function Provider(props) {
  const [language, setLanguage] = useState("GB");
  const [pickUpDate, setPickUpDate] = useState(null);
  const [dropOffDate, setDropOffDate] = useState(null);
  const [dropOffTime, setDropOffTime] = useState(null);
  const [dropOffLocation, setDropOffLocation] = useState(null);
  const [pickUpTime, setPickUpTime] = useState(null);
  const [pickUpLocation, setPickUpLocation] = useState(null);
  const [carToReserve, setCarToReserve] = useState(null);
  const [extrasPicked, setExtrasPicked] = useState([]);
  const [windowHeight, windowWidth] = useWindowSize();
  const [paymentMethod,setPaymentMethod] =useState();
  const [reservationComments,setReservationComments] =useState()
  const [insuranceChecked, setInsuranceChecked] = useState({
    id: null,
    title: '',
    pricePerDay: '',
  });
  const [formBody, setFormBody] = useState({
    customerName: null,
    customerLastName: null,
    customerMail: null,
    customerPhone:null,
    customerAddress: null,
    customerCountry: null,
    flightNumber: null,
  });
  return (
    <ClientContext.Provider
      value={{
        language,
        setLanguage,
        windowHeight,
        windowWidth,
        pickUpDate,
        setPickUpDate,
        dropOffDate,
        setDropOffDate,
        dropOffTime,
        setDropOffTime,
        dropOffLocation,
        setDropOffLocation,
        pickUpTime,
        setPickUpTime,
        pickUpLocation,
        setPickUpLocation,
        carToReserve,
        setCarToReserve,
        extrasPicked,
        setExtrasPicked,insuranceChecked, 
        setInsuranceChecked,
        formBody, setFormBody,
        paymentMethod,setPaymentMethod,
        reservationComments,setReservationComments,
      }}
    >
      {props.children}
    </ClientContext.Provider>
  );
}
